import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "user-anon",
  "use": "user-anon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" id=\"user-anon\"><path d=\"M810.8 298.6c0 164.9-133.7 298.6-298.6 298.6S213.5 463.6 213.5 298.6 347.2 0 512.1 0C677 0 810.8 133.7 810.8 298.6zM743 605c-63.3 48.5-143.5 77.7-230.6 77.7S345 653.5 280.8 604.3l.9.7C107.5 681.5 0 919.6 0 1024h1024c0-103.2-110.9-341.6-281.5-418.8l.5-.2z\" /><circle cx=\"784\" cy=\"767.9\" r=\"240\" fill=\"#fff\" /><path d=\"M849.4 643.6c-18.2-13.2-41.2-19.7-68.7-19.7-21 0-38.7 4.6-53.1 13.9-22.8 14.5-35 39.1-36.4 73.8h52.9c0-10.1 3-19.8 8.8-29.2 5.9-9.4 15.9-14.1 30-14.1 14.4 0 24.3 3.8 29.7 11.4 5.4 7.6 8.1 16.1 8.1 25.3 0 8.1-4 15.4-8.9 22.1-2.7 3.9-6.2 7.5-10.6 10.8 0 0-28.7 18.4-41.3 33.2-7.3 8.6-8 21.4-8.6 39.8 0 1.3.5 4 5 4h41.1c4.1 0 4.9-3 5-4.4.3-6.7 1-10.1 2.3-14 2.3-7.3 8.6-13.7 15.7-19.2l14.6-10c13.2-10.3 23.6-18.7 28.3-25.2 7.9-10.8 13.5-24.2 13.5-40 0-25.8-9.1-45.3-27.4-58.5zm-69.6 203.1c-18.2-.6-33.3 12.1-33.8 31.8-.6 19.7 13.7 32.8 32 33.3 19 .6 33.7-11.6 34.3-31.4.5-19.7-13.4-33.2-32.5-33.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/user-anon.svg
// module id = 0mht
// module chunks = 1